export const WEEKDAY_DE = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
export const MONTH_DE = ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'];

export function parseLocalDate(dateStr) {
  if (!dateStr) return null;
  const [y, m, d] = dateStr.split('-').map(Number);
  return new Date(y, m - 1, d);
}

export function groupEventsByDate(events) {
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const tomorrow = new Date(today); tomorrow.setDate(today.getDate() + 1);
  const dayOfWeek = today.getDay() === 0 ? 6 : today.getDay() - 1;
  const thisWeekEnd = new Date(today); thisWeekEnd.setDate(today.getDate() + (6 - dayOfWeek) + 1);
  const nextWeekEnd = new Date(thisWeekEnd); nextWeekEnd.setDate(thisWeekEnd.getDate() + 7);
  const groups = [
    { key: 'past',     label: 'Vergangen',    color: '#9E9E9E', events: [] },
    { key: 'heute',    label: 'Heute',         color: '#E65100', events: [] },
    { key: 'morgen',   label: 'Morgen',        color: '#1565C0', events: [] },
    { key: 'woche',    label: 'Diese Woche',   color: '#2E7D32', events: [] },
    { key: 'naechste', label: 'Nächste Woche', color: '#6A1B9A', events: [] },
    { key: 'spaeter',  label: 'Später',        color: '#5D4037', events: [] },
  ];
  for (const ev of events) {
    const d = parseLocalDate(ev.date);
    if (!d) continue;
    if (d < today)                               groups[0].events.push(ev);
    else if (d.getTime() === today.getTime())    groups[1].events.push(ev);
    else if (d.getTime() === tomorrow.getTime()) groups[2].events.push(ev);
    else if (d < thisWeekEnd)                    groups[3].events.push(ev);
    else if (d < nextWeekEnd)                    groups[4].events.push(ev);
    else                                         groups[5].events.push(ev);
  }
  return groups.filter(g => g.events.length > 0);
}
